/* eslint-disable import/prefer-default-export */

import React from 'react';
import styled from 'styled-components';

import Message from 'antd/lib/message';
import AntdIcon from 'antd/lib/icon';

import Admin from 'hive-admin';

import FieldRichText, {
  createButtonConfig,
} from 'hive-admin/src/components/FieldRichText';

const MagicIconWrapper = styled.span`
  font-size: 90%;
  font-weight: 500;
  color: #666;
  transform: translate(0px, -2px) !important;
  white-space: nowrap;
  > span {
    margin-right: 5px;
    filter: grayscale(1) brightness(0.5);
  }
`;

function MagicIconButton(props) {
  return (
    <MagicIconWrapper
      className={props.className}
      title="Tell Ai what to write, translate or rephrase the current text."
    >
      <span>✨</span>
      Ai
    </MagicIconWrapper>
  );
}

MagicIconButton.defaultProps = {
  className: 'anticon anticon-experiment',
};

export const getButtonsMap = (fieldConfig) => {
  // eslint-disable-next-line no-unused-vars
  const magicTetxtButtonConfig = createButtonConfig({
    id: 'magic-text',
    title: 'Tell Ai what to write, translate or rephrase the current text.',
    label: <MagicIconButton />,
    getLabel: (editor, config, props, input) => (
      input.state.loadingMagicText
      ? <AntdIcon type="loading" spin />
      : <MagicIconButton />
    ),
    isActive: (editor, config, props, input) => (
      !!input.state.loadingMagicText
    ),
    // onClick: editor => editor.handleMagicText(),
    onClick: (editor, config, props, input) => {
      const { value } = input.props;
      if (value && value.length) {
        const rootForm = (
            input.props.forms?.length
          ? input.props.forms[input.props.forms.length - 1]
          : input.props.form
        );
        let language = 'en';
        const languageCode = rootForm.getFieldValue('i18nLanguage');
        if (rootForm) {
          if (languageCode) {
            language = languageCode;
          }
        }
        input.setState({ loading: true, loadingMagicText: true });
        input.props.client.request({
          url: '/magic-text/auto',
          method: 'POST',
          data: {
            language,
            targetUse: (
              input.props.editorMode === 'inline'
              ? 'Title'
              : 'Text'
            ),
            input: input.props.value,
          },
        })
        .then((response) => {
          const { data: { html } = {} } = response;
          if (html?.length) {
            input.handleChange(html);
            Message.success('Done!');
          } else {
            throw new Error('Generated output was empty');
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log('error generating magic text:', error);
          Message.error(`Error generating output: ${
            error.response?.data?.message || error.message
          }`);
        })
        .then(() => {
          input.setState({ loading: false, loadingMagicText: false });
        });
      }
    },
  });
  return {
    ...fieldConfig.buttonsMap,
    // [magicTetxtButtonConfig.id]: magicTetxtButtonConfig,
  };
};

const InitialRichText = Admin.getFromLibrary('FieldRichText');

Admin.addToLibrary('FieldRichText', (customConfig = {}) => (
  Admin.compileFromLibrary([InitialRichText, {
    ...customConfig,
    getButtonsMap,
    menuBarButtons: [
      ...(customConfig.menuBarButtons || FieldRichText.config.menuBarButtons),
      // 'magic-text',
    ],
    menuTooltipButtons: [
      ...(
        customConfig.menuTooltipButtons
        || FieldRichText.config.menuTooltipButtons
      ),
      // 'magic-text',
    ],
  }])
));

const InitialRichTextInline = Admin.getFromLibrary('FieldRichTextInline');

Admin.addToLibrary('FieldRichTextInline', (customConfig = {}) => (
  Admin.compileFromLibrary([InitialRichTextInline, {
    ...customConfig,
    getButtonsMap,
    menuBarButtons: [
      ...(customConfig.menuBarButtons || FieldRichText.config.menuBarButtons),
      'magic-text',
    ],
    menuTooltipButtons: [
      ...(
        customConfig.menuTooltipButtons
        || FieldRichText.config.menuTooltipButtons
      ),
      'magic-text',
    ],
  }])
));
